import * as React from "react";
import {Button} from "antd";
import styled from "styled-components";

export const CancelButton = styled(Button)`
  padding: 8px 24px 8px 24px;
  border-radius: 4px;
  color : #45505A;
  border: 1px solid #A9B3BC;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  height: 100%;
  &:hover {
    border-color: #A9B3BC !important;
    color: #76838F !important;
  }
`

const OkButton = styled(Button)`
  &:hover {
    background-color: #56ADF3 !important;
  }
`

type EditInfoFooterProps = {
  onSave: React.MouseEventHandler<HTMLElement> | undefined;
  onCancel: () => void;
  isBottom?: boolean;
}

export const EditInfoFooter = ({ onSave, onCancel, isBottom } : EditInfoFooterProps) => {
  return (
    <footer className={isBottom ? "without-border" : "with-border"}>
      <div style={{maxWidth: '700px'}}>
        <div className="d-flex gap-3">
          <OkButton type="primary" onClick={onSave}>Сохранить</OkButton>
          <CancelButton onClick={onCancel}>Отмена</CancelButton>
        </div>
      </div>
    </footer>
  )
}